<script lang="ts">
  import { onMount } from 'svelte';
  import { store } from '$lib/store.svelte';
  import Sidebar from './components/Sidebar.svelte';
  import CaptureBar from './components/CaptureBar.svelte';
  import MobileBar from './components/MobileBar.svelte';
  import Ideas from './views/Ideas.svelte';
  import Agentes from './views/Agentes.svelte';
  import Archivo from './views/Archivo.svelte';
  import SyncView from './views/Sync.svelte';

  let sidebarOpen = $state(false);
  let toasts = $state<{ id: number; msg: string; type: string }[]>([]);
  let toastSeq = 0;

  function toast(msg: string, type: 'success' | 'warning' = 'success') {
    const id = ++toastSeq;
    toasts = [...toasts, { id, msg, type }];
    setTimeout(() => {
      toasts = toasts.filter((t) => t.id !== id);
    }, 2800);
  }

  onMount(async () => {
    await store.init();
  });

  function openSidebar() { sidebarOpen = true; }
  function closeSidebar() { sidebarOpen = false; }

  function handleViewChange(v: string) {
    closeSidebar();
  }
</script>

<div class="app">
  <Sidebar
    open={sidebarOpen}
    onClose={closeSidebar}
    onNavigate={handleViewChange}
  />

  {#if sidebarOpen}
    <button
      type="button"
      class="sidebar-overlay show"
      onclick={closeSidebar}
      aria-label="Cerrar menu"
    ></button>
  {/if}

  <main class="main">
    <header class="header">
      <button
        type="button"
        class="menu-toggle icon-btn"
        onclick={openSidebar}
        aria-label="Abrir menu"
      >
        ☰
      </button>
      <CaptureBar onCaptured={() => toast('Idea capturada')} onError={(m) => toast(m, 'warning')} />
      <span class="sync-indicator" title={store.lastSyncMessage}>
        <span class="sync-dot {store.syncStatus}"></span>
      </span>
    </header>

    <section class="content">
      {#if store.view === 'ideas'}<Ideas onMessage={toast} />
      {:else if store.view === 'agentes'}<Agentes onMessage={toast} />
      {:else if store.view === 'archivo'}<Archivo onMessage={toast} />
      {:else if store.view === 'sync'}<SyncView onMessage={toast} />
      {/if}
    </section>

    <MobileBar />
  </main>

  <div class="toast-container">
    {#each toasts as t (t.id)}
      <div class="toast toast-{t.type}">{t.msg}</div>
    {/each}
  </div>
</div>
